import type { FC } from 'react';

import { useGetAppsListQuery } from '@app/api/apps';
import useSelector from '@app/hooks/useSelector';
import { getProject } from '@app/selectors';

import ProjectNavigation from './ProjectNavigation';
import useProjectNavigation from './selectors';

interface ProjectNavigationContainerProps {
    activeItem: string;
}

const ProjectNavigationContainer: FC<ProjectNavigationContainerProps> = ({ activeItem }) => {
    const { id: projectId } = useSelector(getProject);

    const { data = [] } = useGetAppsListQuery({ projectId });

    const navigation = useProjectNavigation({ apps: data });

    return <ProjectNavigation navigation={navigation} activeItem={activeItem} />;
};

export default ProjectNavigationContainer;
